module.exports = __webpack_public_path__ + "static/media/imagebox_3.5728cabc.png";